import React from 'react'
import { ORDER_METHOD } from '../../../constants'
import { clsx } from '../../../utils/helper'

import pickupIcon from '../../../assets/images/pickup.png'
import deliveryIcon from '../../../assets/images/delivery.png'

const ORDER_METHOD_UI = {
    [ORDER_METHOD.DELIVERY]: {
        label: 'Delivery',
        icon: deliveryIcon,
    },
    [ORDER_METHOD.PICKUP]: {
        label: 'Pickup',
        icon: pickupIcon,
    },
}

const OrderMethodItem = ({ className, type, label, ...props }) => {
    const classes = clsx(['desk-order-method', className])
    const ui = ORDER_METHOD_UI[type] || ORDER_METHOD_UI[ORDER_METHOD.PICKUP]

    return (
        <div className={classes} {...props}>
            <div className="icon">
                <img src={ui.icon} />
            </div>
            <div className="name">{label || ui.label}</div>
        </div>
    )
}

export default OrderMethodItem
